function setCookie(cname, cvalue, exdays) {
  setCookieDomain(cname, cvalue, exdays, document.domain);
}

function setCookieDomain(cname, cvalue, exdays, domain) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  const expires = 'expires=' + d.toUTCString();
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/;domain=' + domain;
}

function getCookie(cname) {
  const name = cname + '=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

function setKeepBuyingCookie() {
  const domain = document.domain;
  setCookieDomain('keepBuying', domain, -1, '.' + domain);
}

$(document).ready(() => {
  const urlRedirect = window.location.href;

  if (urlRedirect.split('/')[3] && urlRedirect.split('/')[3] == 'programa-de-beneficios')
    setCookie('loginOriginUrl', '/programa-de-beneficios/usuario/');
  else setCookie('loginOriginUrl', '', -1);

  document.cookie = 'lumRequestPrevPage=' + encodeURIComponent(window.location.href) + ';path=/';

  setKeepBuyingCookie();
});
